var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06519 1.28822L23.2204 23.4435L24.3495 22.3144L19.3805 17.3455C22.3627 15.0441 24.3001 12.1593 24.3001 12.1593C24.3001 12.1593 18.9386 4.17578 12.3248 4.17578C10.6196 4.17578 8.99762 4.7065 7.52931 5.49427L2.19422 0.15918L1.06519 1.28822ZM9.47857 7.44353C10.237 7.06564 11.175 6.83282 12.3248 6.83282C16.7374 6.83282 17.9952 10.2334 17.9952 12.1593C17.9952 12.9939 17.759 14.1054 17.1322 15.0971L9.47857 7.44353ZM14.6403 17.1053L16.6163 19.0813C15.2841 19.7253 13.8372 20.1428 12.3248 20.1428C5.7111 20.1428 0.349609 12.1593 0.349609 12.1593C0.349609 12.1593 2.10454 9.5461 4.84488 7.30986L7.23194 9.69692C6.79353 10.5605 6.61945 11.463 6.61945 12.1593C6.61945 14.0567 7.91226 17.4857 12.3248 17.4857C13.2217 17.4857 13.9882 17.3453 14.6403 17.1053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclosed);
export default __webpack_public_path__ + "static/media/eyeclosed.191cda2ee85ef13c9ab86066594af92b.svg";
export { ForwardRef as ReactComponent };